import React from 'react';
import PropTypes from 'prop-types';
import $ from "jquery";
import Loading from "shared/loading";
import Toast from "shared/toast";
import MoveVirtualLineForm from "shared/virtual_line_modal/components/move_virtual_line_form";
import Modal from "shared/react_components/Modal";
import ModalButtonRow from "../components/ModalButtonRow";
import VirtualLineMover from "../models/virtual_line_mover";

export default class MoveVirtualLineModal extends React.Component {
  constructor(props) {
    super(props);

    this.modalRef = React.createRef();
    this.successCallback = props.config.successCallback;

    const modelAttributes = props.model.attributes;
    const virtualLineMoverConfig = {
      id:                               modelAttributes.id,
      promoNumber:                      modelAttributes.virtual_line_name,
      hasCustomData:                    props.config.hasCustomData,
      originalAdvertiserCampaignId:     modelAttributes.advertiser_campaign_id,
      originalAffiliateId:              modelAttributes.affiliate_campaign_id,
      moveAdvertiserCampaignsUrl:       props.config.moveAdvertiserCampaignsUrl,
      moveUrl:                          props.config.moveUrl,
      destinationAdvertiserCampaignUrl: `${props.config.moveAdvertiserCampaignsUrl}&version=1`,
      affiliateUrlBase:                 props.config.moveAffiliateCampaignsUrl
    };

    const virtualLineMover = new VirtualLineMover(virtualLineMoverConfig);

    this.state = {
      virtualLineMover:   virtualLineMover,
      isOpen:             true,
      valid:              false
    };
  }

  render() {
    const buttonRow = <ModalButtonRow
      toggle={this.toggleModal.bind(this)}
      submitAction={this.onMove.bind(this)}
      errorMessage={this.state.virtualLineMover.errorMessages()}
      valid={this.state.valid} />;

    return (
      <div ref={this.modalRef}>
        <Modal
          isOpen={this.state.isOpen}
          toggle={this.toggleModal.bind(this)}
          buttons={buttonRow}
          title={"Move Promo Number"}
          className={"modal-force-light"}
          large={false}>
          <MoveVirtualLineForm
            virtualLineMover={this.state.virtualLineMover}
            updateForm={this.updateVirtualLineMover.bind(this)}
          />
        </Modal>
      </div>
    );
  }

  toggleModal() {
    this.setState({ isOpen: false });
  }

  updateVirtualLineMover(virtualLineMover) {
    const validState = virtualLineMover.valid();
    this.setState({ valid: validState, virtualLineMover: virtualLineMover });
  }

  onMove() {
    if (this.state.virtualLineMover.valid()) {
      this._configureLoadingMask();
      this.state.virtualLineMover.save(this._onRequestSuccess.bind(this), this._setErrorAndRender.bind(this));
    } else {
      this.updateVirtualLineMover(this.state.virtualLineMover);
    }
  }

  _onRequestSuccess(model) {
    Toast.success({
      title: `Successfully moved Promo Number`,
      message: `The Promo Number ${model.promoNumber} has been moved to ${model.destinationLabel}`,
      sticky: true,
      action: {
        text: "View Campaign",
        href: model.destinationUrl,
        target: '_blank'
      }
    });

    this.successCallback(model);
    this.toggleModal();
  }

  _setErrorAndRender(errorMessages) {
    Loading.hide();
    this._updateToInvalid(errorMessages);
  }

  _updateToInvalid(errorMessages) {
    const virtualLineMover = this.state.virtualLineMover;
    virtualLineMover.errors = { headerErrors: errorMessages };
    this.setState({ virtualLineMover: virtualLineMover, valid: false });
  }

  _configureLoadingMask() {
    Loading.show($(this.modalRef.current));
  }
}

MoveVirtualLineModal.propTypes = {
  model:  PropTypes.object.isRequired,
  config: PropTypes.object.isRequired
};
